<template>
  <div>
    <review-photo-swipe :photos="entry.entry.photos"/>
    <div class="project-content container">
      <h1 class="project-heading pt-5">
        <span class="project-title">{{entry.entry.title | capitalize}}</span>
        <span class="project-photographer">{{entry.name.toLowerCase() }}</span>
      </h1>
      <review-entry-meta :entry="entry"/>
      <!-- .project-meta-->
      <div class="project-statement pt-5 pb-4">{{entry.entry.statement}}</div>

      <review-photo-card v-for="photo in slides" :key="photo.pid" :photo="photo" :slides="slides"/>
    </div>
    <!-- .project-content -->
  </div>
</template>

<script>
import ReviewPhotoCard from '@/components/review/ReviewPhotoCard.vue'
import ReviewPhotoSwipe from '@/components/review/ReviewPhotoSwipe.vue'
import ReviewEntryMeta from '@/components/review/ReviewEntryMeta.vue'
export default {
  components: { ReviewPhotoCard, ReviewPhotoSwipe, ReviewEntryMeta },
  props: {
    entry: {
      type: Object,
      required: true
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString().toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    // convert the photo object to an array
    slides: function() {
      let photos = []
      const photoArray = Object.values(this.entry.entry.photos)
      let i = 0
      photoArray.forEach(photo => {
        let slide = {
          i: i,
          src: photo.filePath,
          w: photo.width,
          h: photo.height,
          ...photo
        }
        photos.push(slide)
        i++
      })
      return photos
    }
  }
}
</script>

<style >
div.project-statement {
  white-space: pre-line;
  white-space: pre-wrap;
  padding-top: 1em;
}
.project-heading {
  font-weight: 200;
}
.project-photographer {
  text-transform: capitalize;
}
.project-photographer {
  font-size: 0.6em;
  font-weight: 300;
}
.project-photographer:before {
  content: ' by ';
  text-transform: lowercase;
}
.project-entrant-contact span:before {
  content: ' | ';
}
.project-entrant-contact span:first-child:before {
  content: '';
}
.project-entrant-resident {
  padding-left: 0.5em;
}
.project-entrant-address {
  font-style: italic;
  font-size: 0.9em;
  padding-left: 0.5em;
}
.project-entrant-contact a {
  color: #707070;
  text-decoration: underline;
}
.project-entrant-contact a:hover {
  color: #343a40;
  text-decoration: underline;
}
</style>
